import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './firebase';
import './estilo.css';

export default function ListarUsuarios({ usuario }) {
  const [usuariosCadastrados, setUsuariosCadastrados] = useState([]);

  useEffect(() => {
    if (usuario?.email === 'thiago@capilaressencia.com.br') {
      carregarUsuarios();
    }
  }, [usuario]);

  async function carregarUsuarios() {
    const querySnapshot = await getDocs(collection(db, 'usuarios'));
    const lista = querySnapshot.docs.map(docRef => docRef.data());
    setUsuariosCadastrados(lista);
  }

  if (!usuario || usuario.email !== 'thiago@capilaressencia.com.br') {
    return null;
  }

  return (
    <div className="card">
      <h2>Lista de Usuários Cadastrados</h2>

      {usuariosCadastrados.length === 0 && <p>Nenhum usuário encontrado.</p>}

      {usuariosCadastrados.map((u, idx) => (
        <div key={idx} className="sistema-item">
          <p><b>Nome:</b> {u.nome}</p>
          <p><b>Email:</b> {u.email}</p>
          <p><b>Time:</b> {u.time}</p>
          <p><b>Criado em:</b> {new Date(u.criadoEm).toLocaleString()}</p>
          <hr />
        </div>
      ))}
    </div>
  );
}